import { Fragment } from "preact";
import { useState, useMemo } from 'preact/hooks';
import { infos_to_display, caption_ellipsis } from "../settings";
import { MwlIcons } from "../components/MwlIcons";

export const Description = ({ image }) => {
  const [ showFullDescription, setShowFullDescription ] = useState(false);
  const caption = image.caption || (image.meta && image.meta.caption);
  const hasLongCaption = (caption?.length ?? '') > 150;
  
  const processedCaption = useMemo(() => {
    if (!caption_ellipsis || !hasLongCaption || showFullDescription) {
      return caption;
    }
    return caption.substr(0, 150);
  }, [showFullDescription, hasLongCaption, caption]);

  if (!infos_to_display.caption || !caption) {
    return null;
  }

  //Add a wheel event listener to the caption to allow scrolling when the caption is too long
  const handleWheel = (e) => {
    const captionElement = e.currentTarget;
    if (captionElement.scrollHeight > captionElement.clientHeight) {
      captionElement.scrollTop += e.deltaY;
      e.preventDefault();
    }
  };

  return (
    <Fragment>
      <div className="description visible">
        <div className="caption-wrapper" onWheel={handleWheel}>
          <span className="caption" dangerouslySetInnerHTML={{ __html: processedCaption }}></span>
           {caption_ellipsis && hasLongCaption &&
          <span className="toggle-full-description" onClick={() => setShowFullDescription(!showFullDescription)}>
            <MwlIcons icon={showFullDescription ? "close_arrow" : "ellipsis"} />
          </span>
        }
        </div>
       
      </div>
    </Fragment>
  );
};